import { Card } from '@chakra-ui/react';

type Props = {
  title: string;
  isActive?: boolean;
  children: React.ReactNode;
};

/**
 * Step.
 *
 * Step component used with <Wizard />. Simple card with an active
 * flag. `title` and `subTitle` are used in <Wizard /> to map
 * children.
 *
 * @param {Props}
 * @returns {JSX.Element | null}
 */
export function Step({ isActive = false, title, children }: Props): JSX.Element | null {
  return isActive ? (
    <Card aria-label={title} variant="divider-top" w="full">
      {children}
    </Card>
  ) : null;
}

export type StepProps = Props;
